export default "__VITE_ASSET__D8i3bjPQ__"